
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.1 28.184l-7.882-7.882a12.302 12.302 0 002.3-7.16c0-6.824-5.551-12.375-12.376-12.375C6.318.767.767 6.318.767 13.143c0 6.824 5.55 12.374 12.375 12.374 2.669 0 5.136-.858 7.16-2.3l7.882 7.884c.402.402.93.604 1.458.604.529 0 1.056-.202 1.458-.604a2.059 2.059 0 000-2.916zm-16.926-8.982v1.16a1.031 1.031 0 11-2.063 0V19.2a4.242 4.242 0 01-1.745-.823 1.03 1.03 0 01-.149-1.453 1.027 1.027 0 011.45-.148c.39.319.915.491 1.475.491 1.118 0 2.063-.707 2.063-1.546 0-.84-.945-1.547-2.063-1.547-2.275 0-4.125-1.62-4.125-3.61 0-1.677 1.32-3.077 3.094-3.482V5.923a1.031 1.031 0 112.063 0v1.162a4.258 4.258 0 011.745.822c.443.359.51 1.008.148 1.45a1.03 1.03 0 01-1.45.149c-.39-.316-.914-.489-1.475-.489-1.117 0-2.062.708-2.062 1.547 0 .84.945 1.547 2.062 1.547 2.276 0 4.125 1.619 4.125 3.61 0 1.677-1.32 3.076-3.093 3.481z","fill":"#fff"}})])
          )
        }
      }
    